import { fade } from "@material-ui/core/styles";

export const dark = {
    outline: "#212121",
    outline_alt: "#9f9f9f",
    outline_alt2: "#363636",
    fill: "#363636",
    fill2: "#333333",
    text: "#fff",
    text_alt: "#fff",
    text_alt2: "#fff",
    text_alt3: "#fff",
    nav_text: "#fff",
    text_backdrop: "rgba(0, 0, 0, 0)",
    button_fill: "#90caf9",
    button_text: "#000",
    button_hover_fill: "#414141",
    button_hover_text: "#c6c6c6",
    modal_fill: "#3f3f3f",
    img_border: "#2b2b2b",
    odd_row: "rgba(255, 255, 255, 0.03)",
    even_row: "rgba(255, 255, 255, 0.05)",
    span: "#ff867c",
    offset: "#ef5350",
    span_alt: "#ff867c",
    // span: "#ffc4ff",
    // offset:  "#ce93d8",
    // span_alt: "#ffc4ff",
    arrow_active: "#fff",
    arrow_inactive: "#dc0000",
    location_button_selected: "#90caf9",
    light_normal: fade("#fff", 0.115),
    dark_normal: fade("#fff", 0.085),
    light_in_range: "#0081cb",
    dark_in_range: "#0081cb",
    sqr_text_light: "#a9a9a9",
    sqr_text_dark: "#ffffff",
    sqr_border: "#00CCff",
    sqr_text: "#000",
    sqr_hover: "rgba(255, 255, 255, 0.2)",
    sqr_hover_alt: "#669df6",
    page_link: "#b6b6b6",
    page_link_hover: "#90caf9",
    drawer_outline: "#373737",
    switch_active: "#0081cb",
    modal_actions: "#90caf9",
    location_sqr: "#0081cb",
    text_link: "#90caf9",
    title: "#90caf9",
    site_description_backdrop: "rgba(0, 0, 0, 0)",
    site_description_text: "#c6c6c6",
    menu_container: "#313131",
    stepper_fill: "",
    stepper_label: "",
    stepper_label_active: "",
    stepper_label_completed: "",
    step_icon_text: "",
    step_icon_active: "",
    step_icon_completed: "",
    variant_fill_r0: 157,
    variant_fill_g0: 80,
    variant_fill_b0: 226,
    variant_stroke_r0: 0,
    variant_stroke_g0: 0,
    variant_stroke_b0: 255,
    variant_fill_r1: 236,
    variant_fill_g1: 37,
    variant_fill_b1: 37,
    variant_stroke_r1: 157,
    variant_stroke_g1: 80,
    variant_stroke_b1: 120,
};
